export const PreviousSearches = {
    INIT: 'INIT_PREVIOUS_SEARCHES',
    ADD: 'ADD_PREVIOUS_SEARCHES',
};
